import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type emailUpdatePayloadType = {
	group_number: number;
	role: string;
	SSN: string;
	email: string;
};

const initialRoute = "auth";

export const emailUpdate = async (emailUpdatePayload: emailUpdatePayloadType) => {
	try {
		const payload = JSON.stringify(emailUpdatePayload);
		const endpoint = `${initialRoute}/email-update`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				// const {
				// 	data: { result }
				// } = response;
				return message;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
